import { __rest } from "tslib";
import React from 'react';
import clsx from 'clsx';
import './ButtonGrid.less';
export default function ButtonGrid(props) {
    const { className } = props, otherProps = __rest(props, ["className"]);
    return React.createElement("div", Object.assign({ className: clsx(className, 'kal-btn-grid') }, otherProps));
}
//# sourceMappingURL=ButtonGrid.js.map